import { h } from 'preact';

var defaultTemplates = {
    HTMLMarker: function HTMLMarker() {
        return /*#__PURE__*/ h("p", null, "Your custom HTML Marker");
    },
    reset: function reset() {
        return 'Clear the map refinement';
    },
    toggle: function toggle() {
        return 'Search as I move the map';
    },
    redo: function redo() {
        return 'Redo search here';
    }
};

export { defaultTemplates as default };
